module.exports = __webpack_public_path__ + "staticPO/img/NIBMFees.d7867b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NIBMFees.jpg
// module id = bQI5
// module chunks = 1